import RightArrow from '@mui/icons-material/ChevronRightRounded';
import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CategoriesIcon from 'assets/icons/watchlist/category.svg';
import PayeeIcon from 'assets/icons/watchlist/payee.svg';
import TagsIcon from 'assets/icons/watchlist/tags.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(({ typography, palette, spacing }) => ({
  headlineRoot: {
    padding: '24px 0 0 168px',
  },
  typeSelectorRoot: {
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginLeft: 168,
    marginRight: 24,
  },
  typeSelectorBtnRoot: {
    border: `1px solid ${palette.border.main}`,
    borderRadius: 8,
    margin: spacing(1),
    width: '100%',
    height: 68,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: palette.background.default,
    },
  },
  typeSelectorImage: {
    width: 30,
    height: 30,
    marginLeft: 20,
  },
  typeSelectorLabel: {
    ...typography.titleRegular,
    display: 'block',
    marginLeft: 20,
  },
  rightArrow: {
    marginRight: 20,
  },
}));

const TypeSelector = (props) => {
  const { typesData, onTypeClick } = props;
  const { classes } = useStyles();

  return (
    <Grid item container>
      <Grid className={classes.headlineRoot} item container>
        <Typography variant='bodyRegular' color={'textSecondary'}>
          Keep an eye on spending in areas that are important to you by adding a Watchlist.
        </Typography>
      </Grid>
      <Grid className={classes.typeSelectorRoot} item container>
        {typesData &&
          Object.keys(typesData).map((typeId) => {
            const type = typesData[typeId][0];
            const onClick = () => onTypeClick(typeId);
            let imgSrc;
            let id;
            switch (typeId) {
              case 'CHARTOFACCOUNT':
                imgSrc = CategoriesIcon;
                id = 'categories';
                break;
              case 'PAYEE':
                imgSrc = PayeeIcon;
                id = 'payees';
                break;
              case 'TAG':
                imgSrc = TagsIcon;
                id = 'tags';
                break;
              default:
                break;
            }
            return (
              <ButtonBase
                key={typeId}
                id={`creator-by-option-${id}`}
                className={classes.typeSelectorBtnRoot}
                onClick={onClick}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img className={classes.typeSelectorImage} src={imgSrc} alt={type} />
                  <span className={classes.typeSelectorLabel}>{type}</span>
                </div>
                <RightArrow className={classes.rightArrow} />
              </ButtonBase>
            );
          })}
      </Grid>
    </Grid>
  );
};

TypeSelector.propTypes = {
  onTypeClick: PropTypes.func,
  typesData: PropTypes.object,
};

TypeSelector.whyDidYouRender = true;

export default TypeSelector;
